<div class="settings-card">
  <h2>{{ "settings.title" | translate }}</h2>
  <div class="setting-row">
    <label for="showListByBranch">{{ "settings.showListByBranch" | translate }}</label>
    <p-inputSwitch
      id="showListByBranch"
      [(ngModel)]="showListByBranch"
      (onChange)="onToggle()"
    ></p-inputSwitch>
  </div>
</div>
